<!-- Input -->
<mat-form-field>
    <mat-label>Label</mat-label>
    <input matInput>
</mat-form-field>

<!-- Select -->
<mat-form-field>
    <mat-label>Label</mat-label>
    <mat-icon fontSet="material-symbols-outlined" matSuffix>stat_minus_1</mat-icon>
    <mat-select formControlName="mobcode">
        <mat-option>
            Option 1
        </mat-option>
    </mat-select>
</mat-form-field>

<!-- Radio -->
<div class="f-row validation-col">
    <label class="mat-label">Label</label>
    <mat-radio-group aria-label="Select an option">
        <mat-radio-button selected>Acceptance</mat-radio-button>
        <mat-radio-button>Denied</mat-radio-button>
    </mat-radio-group>
</div>

<!-- Checkbox -->
<div class="f-row validation-col">
    <label class="mat-label">Label</label>
    <div class="f-row mat-check-group">
        <mat-checkbox class="checkbox-wrapper">All</mat-checkbox>
        <mat-checkbox class="checkbox-wrapper">Flight</mat-checkbox>
    </div>
</div>

<!-- Upload -->
<div class="f-row">
    <div class="fill-manually">
        <div class="f-col">
            <div class="add-text-input">Upload digital signature</div>
            <p>Max size 800x120px and Min size 80pxx80px, Allowed file type are .jpeg, .jpg, .png, .gif</p>
        </div>
        <span>
            <mat-icon fontSet="material-symbols-outlined">add_circle</mat-icon>
        </span>
    </div>
</div>



<!-- Icons -->
<mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
<mat-icon fontSet="material-symbols-outlined" matSuffix>mail</mat-icon>
<mat-icon fontSet="material-symbols-outlined" matSuffix>phone_android</mat-icon>